<div class="body-container mx-auto">
  <form
    class="reg-form"
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
  >
    <header>
      <h1 class="page-title text-center">
        Welcome Back!
      </h1>
    </header>
    <div class="reg-form-content">
      <p class="page-subtitle text-center mt-3 mb-4">Log into your Camp Bow Wow<sup>&#174;</sup> account.</p>
      <div class="input-container">
        <span class="input-label">Email Address</span>
        <input
          title="email"
          type="text"
          class="input"
          formControlName="email"
        >
        <span
          class="error"
          *ngIf="f.email.touched && f.email.value === ''"
        >Please enter email address.</span>
        <span
          class="error"
          *ngIf="f.email.touched && f.email.status === 'INVALID' && f.email.value !== ''"
        >Please check email address. E.g. woof@example.com</span>
      </div>
      <div class="input-container">
        <span class="input-label">Password</span>
        <app-password-input formControlName="password"></app-password-input>
        <span
          class="error"
          *ngIf="f.password.touched && f.password.value === ''"
        >Please enter password.</span>
      </div>
      <div class="action-container">
        <button
          type="submit"
          class="btn btn-danger btn-block"
          tabindex="0"
        >Sign In</button>
      </div>
      <div class="row no-gutters justify-content-between align-items-center mt-3">
        <div class="col-auto">
          <mat-slide-toggle
            style="font-size: 0.75rem"
            formControlName='rememberMe'
            (click)="rememberMeToggle()"
          >Remember Me</mat-slide-toggle>
        </div>
        <div class="col-auto">
          <span
            class="lato black"
            style="font-size: 0.75rem"
          >Don't have an account? </span>
          <a
            class="link"
            routerLink="/register"
            (click)="navigateToRegister()"
          >Sign Up</a>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col text-right">
          <a
            class="link"
            routerLink="/forgot-password"
            (click)="navigateToForgotPassword()"
          >Forgot Password?</a>
        </div>
      </div>
    </div>
  </form>
</div>
